export const PhoneIcon = () => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		width="25"
		height="24"
		viewBox="0 0 25 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g id="tdesign:call">
			<path
				id="Vector"
				d="M1.668 2H10.248L11.735 8.69L9.875 10.55C10.9686 12.252 12.4157 13.6988 14.118 14.792L15.978 12.933L22.668 14.42V23H21.668C17.8183 23.0066 14.0494 21.8964 10.818 19.804C8.43522 18.262 6.40604 16.2328 4.864 13.85C2.77162 10.6186 1.66143 6.84967 1.668 3V2ZM3.695 4C3.86351 7.11991 4.84572 10.1414 6.544 12.764C7.93232 14.909 9.75904 16.7357 11.904 18.124C14.5266 19.8223 17.5481 20.8045 20.668 20.973V16.024L16.615 15.124L14.441 17.299L13.778 16.922C11.2606 15.4915 9.17654 13.4074 7.746 10.89L7.369 10.227L9.544 8.053L8.644 4H3.695Z"
				fill="#998C9C"
			/>
		</g>
	</svg>
);
